import { mapDTO } from '@twistezo/ts-dto-mapper'

import { ProposalsDataDTO } from 'features/globalSetup/api/types/gamOrderRetargetingDealsDeliveryDTO'
import { ProposalIdItem, Schema } from '../../../schema'
import { Variables } from './types'

export const toDTO = (from: Schema): Variables =>
  mapDTO<Schema, Variables>({ from }).transform((data: Schema): Variables => {
    const { currency, geo, proposalsData } = data

    return {
      currency: currency.value,
      geo: geo.value,
      proposalsData: proposalsData.map(proposalItemToDTO),
    }
  })

const proposalItemToDTO = (from: ProposalIdItem): ProposalsDataDTO =>
  mapDTO<ProposalIdItem, ProposalsDataDTO>({ from }).transform(
    (item: ProposalIdItem): ProposalsDataDTO => {
      const { maxPrice, minPrice, proposalId, step } = item

      return {
        maxPrice,
        minPrice,
        proposalId: parseInt(proposalId),
        step,
      }
    },
  )
